import { CommonModule, DatePipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { TranslateModule } from "@ngx-translate/core";
import { BasicFormInputComponent } from "@shared/form/basic/basic-form-input.component";
import { CabLabelComponent } from "@shared/form/components/cab-label/cab-label.component";
import { dateToStringFormat, stringToDateFormat } from "@shared/utils/date";
import { CalendarModule, CalendarTypeView } from "primeng/calendar";
import { distinctUntilChanged, tap } from "rxjs";
/*eslint-disable*/

@UntilDestroy()
@Component({
  selector: "app-cab-calendar",
  standalone: true,
  imports: [
    CommonModule,
    CalendarModule,
    FormsModule,
    CabLabelComponent,
    TranslateModule,
  ],
  providers: [DatePipe],
  templateUrl: `./cab-calendar.component.html`,
  styleUrl: "./cab-calendar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CabCalendarComponent extends BasicFormInputComponent {
  @Input() minDate: Date | null | undefined;
  @Input() maxDate: Date | null | undefined;
  @Input() defaultDate: Date;
  @Input() showTime = false;
  @Input() timeOnly = false;
  @Input() showIcon = true;
  @Input() iconDisplay = true;
  @Input() touchUI: boolean;
  @Input() view: CalendarTypeView = "date";
  @Input() hourFormat = "24";
  @Input() dateFormat = "dd.mm.yy";
  @Input() styleCalendar = { width: "100%", height: "32px" };
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() selectionMode: "single" | "range" | "multiple" = "single";
  @Input() placeholder = "DATAPICKER.TITLE";
  @Input() dateType: "date" | "string" = "date";
  @Input() clearable = false;
  @Input() isConcatZero = false;
  @Output() onDateChange = new EventEmitter();
  value: any;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.setDateToCalendar(this.formControl.value ?? this.defaultDate);
    this.formControl.valueChanges
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged(),
        tap((val) => this.setDateToCalendar(val))
      )
      .subscribe();
  }

  onDateSelect(event) {
    this.setDateToFormControl(this.value);
  }

  onDateInput(event) {
    if (this.value === null) {
      this.formControl.setValue(null);
      this.onDateChange.emit(null);
    } else this.setDateToFormControl(this.value);
  }

  setDateToCalendar(val) {
    this.value = this.dateType === "string" ? stringToDateFormat(val) : val;
    this.changeDetectorRef.detectChanges();
  }

  setDateToFormControl(val) {
    const date =
      this.dateType === "string"
        ? dateToStringFormat(val, this.view, this.isConcatZero)
        : val;
    this.onDateChange.emit(date);
    this.formControl.setValue(date);
  }

  onClear() {
    this.formControl.setValue(null);
    this.onDateChange.emit(null);
  }
}
